import React from 'react';
import * as S from './styles';
import { StatusTagProps } from './types';

function ForwardedStatusTag<
  T extends Element = HTMLDivElement,
  As extends React.ElementType = 'div',
>(
  { as, children, className, color = 'primary', ...props }: StatusTagProps<As>,
  forwardedRef: React.ForwardedRef<T>,
) {
  const Component: React.ElementType = as ?? 'div';

  return (
    <S.Root
      as={Component}
      className={className}
      $color={color}
      ref={forwardedRef}
      {...props}
    >
      {children}
    </S.Root>
  );
}

/**
 * A badge that's often used in designs to indicate the status of an operation
 */
export const StatusTag = React.forwardRef(ForwardedStatusTag) as <
  T extends Element = HTMLDivElement,
  As extends React.ElementType = 'div',
>(
  props: StatusTagProps<As> & { ref?: React.Ref<T> },
) => React.ReactElement | null;

export default StatusTag;
